import {
  createTableDefinition,
  type TableDefinition,
} from '@/features/shared/components/tableSystem/tableDefinition';
import { featureStatusOptions } from '@/shared/constants/statusOptions';
import { getDetailLabel } from '@/shared/copy/details';
import type { FeatureStatus } from '@flowqa/shared';

export type FeaturesSortKey = 'name' | 'status' | 'plannedFor' | 'releasedAt';
export type FeaturesSortDirection = 'asc' | 'desc';

export const featuresDefaultSortKey: FeaturesSortKey = 'plannedFor';
export const featuresDefaultSortDirection: FeaturesSortDirection = 'desc';

export const featuresSortFieldMap: Record<FeaturesSortKey, string> = {
  name: 'name',
  status: 'status',
  plannedFor: 'plannedFor',
  releasedAt: 'releasedAt',
};

export const featuresTableDefinition: TableDefinition<FeaturesSortKey, FeatureStatus> =
  createTableDefinition({
    title: 'Features',
    searchAriaLabel: 'Search features',
    columns: [
      { field: 'name', label: 'Feature', mandatory: true, defaultVisible: true },
      { field: 'status', label: getDetailLabel('status'), defaultVisible: true },
      { field: 'suiteLatestRunPassed', label: 'Latest Suites', defaultVisible: true },
      { field: 'testLatestRunPassed', label: 'Latest Tests', defaultVisible: true },
      { field: 'actions', label: getDetailLabel('actions'), defaultVisible: true },
    ],
    defaultSortKey: featuresDefaultSortKey,
    defaultSortDirection: featuresDefaultSortDirection,
    sortOptions: [
      { key: 'plannedFor', label: 'Planned For' },
      { key: 'releasedAt', label: 'Released At' },
      { key: 'name', label: 'Feature' },
      { key: 'status', label: getDetailLabel('status') },
    ],
    sortFieldMap: featuresSortFieldMap,
    statusOptions: featureStatusOptions.map((option) => ({
      value: option.value as FeatureStatus,
      label: option.label,
    })),
  });
